export const tableInitialState = {
  organizations: [],
  page: 1
}

export const tableReducer = (state, action) => {
  if (action.page) {
    return {
      ...state,
      page: action.page
    }
  } else if (action.organizations) {
    return {
      ...state,
      organizations: action.organizations,
      countries: []
    }
  }
  return state
}

export const formInitalState = {
  id: null,
  organizationId: '',
  name: '',
  code: '',
  usdRate: ''
}

export const formReducer = (state, action) => {
  if (action.type === 'update') {
    return { ...state, [action.name]: action.value }
  }
  if (action.type === 'set-state') {
    return action.state
  }
  return state
}
